// extracted by mini-css-extract-plugin
module.exports = {"root":"snack-bar_root__3PTeX","error":"snack-bar_error__2mW01","warning":"snack-bar_warning__2JSbQ","success":"snack-bar_success__89-_v"};